module.exports = {
  annotate: require(275).annotate,
  Module: require(278),
  Injector: require(277)
};
